import styled from 'styled-components';

export const CredentialContainer = styled.div`
  width: 100%;
`;

export const AuxiliarButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
